module.exports = __webpack_public_path__ + "static/img/2-21-漏发补发建单.cd6f171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-21-漏发补发建单.png
// module id = 1357
// module chunks = 0